import {
  ADD_TO_SCHEDULE,
  ADD_TO_SCHEDULE_ERROR,
  ADD_TO_SCHEDULE_SUCCESS,
  CANCEL_VISIT,
  CANCEL_VISIT_ERROR,
  CANCEL_VISIT_SUCCESS,
  DELETE_CALENDAR_EVENT,
  DELETE_CALENDAR_EVENT_ERROR,
  DELETE_CALENDAR_EVENT_SUCCESS,
  EDIT_SCHEDULE,
  EDIT_SCHEDULE_ERROR,
  EDIT_SCHEDULE_SUCCESS,
  GET_APPOINTMENT,
  GET_APPOINTMENT_ERROR,
  GET_APPOINTMENT_SUCCESS,
  GET_CURRENT_SCHEDULE,
  GET_CURRENT_SCHEDULE_ERROR,
  GET_CURRENT_SCHEDULE_SUCCESS,
  GET_PATIENT,
  GET_PATIENT_ERROR,
  GET_PATIENT_SUCCESS,
  GET_SCHEDULE_BY_ID,
  GET_SCHEDULE_BY_ID_ERROR,
  GET_SCHEDULE_BY_ID_SUCCESS,
  GET_VISIT_TYPE_GROUPS,
  GET_VISIT_TYPE_GROUPS_ERROR,
  GET_VISIT_TYPE_GROUPS_SUCCESS,
} from './CalendarConstants'
import { apiCall } from '../../utils/restclient'
import { chancelVisitEndpoint, methods } from '../../utils/apiHelper'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getScheduleInfo = (id, doctorId) => {
  const endpoint = `api/v1/providers/${doctorId}/calendar/schedules/${id}`
  const action = {
    type: GET_SCHEDULE_BY_ID,
  }
  try {
    apiCall(
      endpoint,
      'GET',
      null,
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      {
        success: GET_SCHEDULE_BY_ID_SUCCESS,
        error: GET_SCHEDULE_BY_ID_ERROR,
      },
      null,
      null,
      0,
      false,
    )
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const addToSchedule = ({ TimeZone, Occurrences, Schedules }, providerId) => {
  const endpoint = `api/v1/providers/${providerId}/calendar`
  const action = {
    type: ADD_TO_SCHEDULE,
  }
  const correctBodyObject = Occurrences ? { TimeZone, Occurrences } : { TimeZone, Schedules }
  try {
    apiCall(
      endpoint,
      'POST',
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      JSON.stringify(correctBodyObject),
      {
        success: ADD_TO_SCHEDULE_SUCCESS,
        error: ADD_TO_SCHEDULE_ERROR,
        extraData: Occurrences?.Create[0]?.Type ? Occurrences.Create[0].Type : Schedules.Create[0].Type,
      },
      null,
      null,
      0,
      false,
    )
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatient = (id, visitId) => {
  const endpoint = `api/v1/patients/${id}`
  const action = {
    type: GET_PATIENT,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PATIENT_SUCCESS,
      error: GET_PATIENT_ERROR,
      extraData: { patientId: id, visitId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getAppointmentInfo(appointmentId) {
  const endpoint = `api/v1/visits/${appointmentId}`
  const action = {
    type: GET_APPOINTMENT,
  }
  apiCall(
    endpoint,
    'GET',
    null,
    null,
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    {
      success: GET_APPOINTMENT_SUCCESS,
      error: GET_APPOINTMENT_ERROR,
      extraData: appointmentId,
    },
    null,
    null,
    0,
    false,
  )
  return action
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function editSchedule(scheduleInfo, eventType, providerId) {
  const endpoint = `api/v1/providers/${providerId}/calendar`
  const action = {
    type: EDIT_SCHEDULE,
  }
  apiCall(
    endpoint,
    'POST',
    null,
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    JSON.stringify({
      ...scheduleInfo,
    }),
    {
      success: EDIT_SCHEDULE_SUCCESS,
      error: EDIT_SCHEDULE_ERROR,
      extraData:
        eventType ||
        (scheduleInfo.Occurrences?.Create ?
          scheduleInfo.Occurrences?.Create[0]?.Type
        : scheduleInfo.Schedules?.Create[0]?.Type),
    },
    null,
    null,
    0,
    false,
  )
  return action
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function deleteEvent(eventIds, providerId, timeZone, isSingle) {
  const endpoint = `api/v1/providers/${providerId}/calendar`
  const action = {
    type: DELETE_CALENDAR_EVENT,
  }
  const requestBody =
    isSingle ?
      { Occurrences: { Delete: eventIds }, TimeZone: timeZone }
    : { Schedules: { Delete: eventIds }, TimeZone: timeZone }
  apiCall(
    endpoint,
    'POST',
    null,
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    JSON.stringify(requestBody),
    {
      success: DELETE_CALENDAR_EVENT_SUCCESS,
      error: DELETE_CALENDAR_EVENT_ERROR,
    },
    null,
    null,
    0,
    false,
  )
  return action
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getCurrentSchedule = (fromDateTime, toDateTime, providerId) => {
  const endpoint = `api/v1/providers/${providerId}/calendar?FromDateTime=${encodeURIComponent(
    fromDateTime,
  )}&ToDateTime=${encodeURIComponent(toDateTime)}`
  const action = {
    type: GET_CURRENT_SCHEDULE,
  }
  try {
    apiCall(
      endpoint,
      'GET',
      null,
      null,
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      {
        success: GET_CURRENT_SCHEDULE_SUCCESS,
        error: GET_CURRENT_SCHEDULE_ERROR,
        extraData: providerId,
      },
      null,
      null,
      0,
      false,
    )
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function cancelVisit(visitId, providerId, endpoints, reasonId, comment) {
  const endpoint = chancelVisitEndpoint(visitId)
  const action = {
    type: CANCEL_VISIT,
  }
  const body = reasonId ? JSON.stringify({ ReasonId: reasonId, Comment: comment ?? null }) : null
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, methods.DELETE, null, body, {
      success: CANCEL_VISIT_SUCCESS,
      error: CANCEL_VISIT_ERROR,
      extraData: { visitId, providerId, endpoints },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getVisitTypeGroups(providerId) {
  const endpoint = `api/v1/providers/${providerId}/calendar/visitTypeGroups`
  const action = {
    type: GET_VISIT_TYPE_GROUPS,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_VISIT_TYPE_GROUPS_SUCCESS,
      error: GET_VISIT_TYPE_GROUPS_ERROR,
      extraData: providerId,
    })
    return action
  } catch (e) {}
}
